import { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useGrant, setGrant } from '@/state/impersonation';
import { endImpersonation } from '@/api/console';
import { Trans, useTranslation } from 'react-i18next';

/**
 * Enquanto uma concessão está ativa, TUDO o que a consola pede à API responde
 * como o utilizador-alvo. Isso nunca pode ser ambíguo (padrão Stripe/Zendesk):
 * barra dourada no topo, saída a um clique, e o aviso de que fica registado.
 */
export function ImpersonationBar() {
  const { t } = useTranslation('hq');
  const grant = useGrant();
  const qc = useQueryClient();
  const [leaving, setLeaving] = useState(false);
  if (!grant) return null;

  const leave = async () => {
    setLeaving(true);
    // Revoga no servidor; mesmo que a rede falhe, largamos aqui — o grant tem
    // TTL e expira sozinho. Ficar preso na conta de outrem é o pior cenário.
    await endImpersonation(grant.grantId).catch(() => {});
    setGrant(null);
    qc.clear();   // nada em cache foi respondido para MIM
    setLeaving(false);
  };

  const mins = Math.max(0, Math.round((new Date(grant.expiresAt).getTime() - Date.now()) / 60000));

  return (
    <div className="impersonation-bar" role="status">
      <span className="truncate">
        <Trans t={t} i18nKey="imp.operatingAs" values={{ name: grant.targetName, mins }} components={{ b: <strong /> }} />
      </span>
      <button onClick={leave} disabled={leaving}>{leaving ? t('imp.leaving') : t('imp.end')}</button>
    </div>
  );
}
